import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';
import MessageUtils from "../../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_TAX_BANDS_SUCCESS
} from '../../../types';
import {redirectToPageNotFound} from "../../../../utils/CommonUtils";

export const loadTaxBands = (restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant-settings/${restaurantId}/tax-bands`;

        axios().get(url)
            .then(response => (response.status === 204 || response.status === 400)? redirectToPageNotFound(dispatch) : loadTaxBandsSuccess(dispatch, response))
            .catch(error =>  MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:productsActions.loadingTaxBandsFailure')));
    };
};

const loadTaxBandsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_TAX_BANDS_SUCCESS, payload: response.data });
};



// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/restaurant/TaxBandsActions.js